import { Auth } from "../auth/auth";
import client from "../auth/client";
import { bulkClauseApiPropForLatestUpload } from "../modules/vscDashboard/constants";

export const archiveContractReviewDocuments = async () => {
  const res = await client.post("/doc_review/reset_contract_reviews/");
  return res.data;
};

export const markDocumentAsCompleted = async (docId: string, useSourcingHubFlow?: boolean) => {
  // Use sourcing hub endpoint for sourcing flow, otherwise use doc_review endpoint
  const endpoint = useSourcingHubFlow 
    ? "/sourcing_hub/set_doc_status/" 
    : "/doc_review/set_doc_status/";
  
  // Use different status value for sourcing hub flow
  const docStatus = useSourcingHubFlow 
    ? "Submitted for Approval" 
    : "review_completed";
    
  const res = await client.post(endpoint, {
    doc_id: docId,
    doc_status: docStatus,
  });

  return res.data;
};

export const uploadFilesFromDriveForClauseCheck = async (reqbody: {
  file_objects: { file_name: string; file_id: string }[];
}) => {
  const auth = Auth.getInstance();
  const res = await client.post("/clause_check/multi_upload_drive_to_gcs/", {
    ...reqbody,
    token: auth.getGoogleAccessToken(),
    feature: "clause_check",
  });
  return res.data;
};

export const uploadFilesFromDriveForRFxEvaluation = async (reqbody: {
  file_objects: { file_name: string; file_id: string }[];
}) => {
  const auth = Auth.getInstance();
  const res = await client.post("/rfx_evaluation/multi_upload_drive_to_gcs/", {
    ...reqbody,
    token: auth.getGoogleAccessToken(),
  });
  return res.data;
};

export const extractMetaDataOfDocumentForClauseCheck = async (reqBody: {
  doc_id: string;
}) => {
  const res = await client.post("/clause_check/extract_doc_metadata/", reqBody);
  return res.data;
};

export const getClauseCheckDataForDashboard = async () => {
  const res = await client.get("/clause_check/get_clause_check_data/");
  return res.data;
};

export const getClauseCheckDocumentsDataForDashboard = async (
  reqBody: {
    clause_status: string[];
    page_size?: number;
    page?: number;
  } = {
    clause_status: bulkClauseApiPropForLatestUpload.clause_status,
    page_size: 10,
    page: 1,
  }
) => {
  const res = await client.post(
    `/clause_check/list_clause_check_contracts/?page_size=${reqBody.page_size}&page=${reqBody.page}`,
    reqBody
  );
  return res.data;
};

export const initiateClauseDataExtraction = async (reqBody: {
  doc_id: string;
}) => {
  const res = await client.post("/clause_check/clause_check/", reqBody);
  return res.data;
};

export const archiveClauseCheckDocuments = async (
  reqBody: {
    doc_id: [];
    update_for_all: string;
    status: string;
  } = { doc_id: [], update_for_all: "yes", status: "deleted" }
) => {
  const res = await client.post("/clause_check/update_doc_status/", reqBody);
  return res.data;
};

export const getDraftedContractsCount = async () => {
  const res = await client.get("/draft_contract/count_contracts/");
  return res.data;
};

export const generateContractDrafting = async (reqBody: {
  doc_id: string;
  term_sheet_id: string;
}) => {
  const auth = Auth.getInstance();
  const res = await client.post("/draft_contract/generate_draft_contract/", {
    ...reqBody,
    token: auth.getGoogleAccessToken(),
  });
  return res.data;
};

export const generateRfxGenerator = async (reqBody: {
  rfx_id: string;
  input_form_id: string;
}) => {
  const res = await client.post("/generate_rfx/generate/", reqBody);
  return res.data;
};

export const uploadRfxGeneratorDocFromDrive = async ({
  file_name,
  file_id,
  id_template_mapping,
}: {
  file_name: string;
  file_id: string;
  id_template_mapping: string;
}) => {
  const auth = Auth.getInstance();
  const res = await client.post(
    "/generate_rfx/upload_intake_form_from_drive/",
    {
      file_objects: {
        file_name,
        file_id,
      },
      token: auth.getGoogleAccessToken(),
      id_template_mapping,
    }
  );
  return res.data;
};

export const uploadDraftingDocFromDrive = async ({
  file_name,
  file_id,
  id_template_mapping,
}: {
  file_name: string;
  file_id: string;
  id_template_mapping: string;
}) => {
  const auth = Auth.getInstance();
  const res = await client.post(
    "/draft_contract/upload_intake_form_from_drive/",
    {
      file_objects: {
        file_name,
        file_id,
      },
      token: auth.getGoogleAccessToken(),
      id_template_mapping: id_template_mapping === "" ? "123e4567-e89b-12d3-a456-426614174000" : id_template_mapping,
    }
  );
  return res.data;
};
